<template>
  <div
    class="viewportHeight"
    :style="{ width: window.width + 'px', minHeight: window.height + 'px', height: max ? window.height + 'px' : 'auto' }"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mixin } from '../../mixin';

export default {
  name: 'viewportHeight',
  mixins: [mixin],
  props: {
    max: Boolean,
  },
  created() {
    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.viewportHeight {
  display: flex;
  flex-direction: column;

  @include phone-landscape {
    height: fit-content;
  }
}
</style>
